import React from 'react';
// icons
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
// components
import ToolBarButton from '../ui/toolbar/toolBarButton';
import ToolbarTitle from '../ui/toolbar/toolbarTitle';
import ticketService from 'modules/emergencies/ticketService';
import { useHistory } from 'react-router-dom';
import ToolbarContainer from '../ui/containers/toolbarContainer';
const NewTicketToolbar = ({ className }) => {
  let history = useHistory();

  return (
    <ToolbarContainer>
      <ToolbarTitle>New ticket</ToolbarTitle>
      <ToolBarButton
        onClick={() => {
          ticketService.utils.navigateToList({ history });
        }}
      >
        <CloseIcon />
      </ToolBarButton>
    </ToolbarContainer>
  );
};

export default NewTicketToolbar;
